export default __webpack_public_path__ + "static/media/filling_6.8cb95d4a.webp";